export const ACTING_AS_PARENT = 'parent'

// This is for use with debounced search fields. The user must type in at least this many characters before
// the debounced action will run.
export const MINIMUM_DEBOUNCED_SEARCH_QUERY_LENGTH = 3

/**
 * This is the default value for the region select field.
 * It is used in the following components:
 * - src/components/Modals/RoleModal.tsx
 * */
export const DEFAULT_SELECTED_REGION = 'United States of America'

// Represents the delay in milliseconds before the  debounced function is actually executed.
export const DEBOUNCE_LIMIT = 500

/**
 * Default page size for pagination on tables.
 */
export const DEFAULT_PAGE_SIZE =
  Number(process.env.REACT_APP_PAGINATION_DEFAULT_PAGE_SIZE) ?? 25

/**Number of suggested characters to be displayed in a playlist in Card*/
export const PLAYLIST_TEXT_TRUNCATION_LIMIT_CARD = 35

/**Number of suggested characters to be displayed in a playlist in Modal*/
export const PLAYLIST_TEXT_TRUNCATION_LIMIT_MODAL = 45

/**Maximum number of playlists allowed */
export const MAX_PLAYLISTS_PER_USER = 30

export const DEBOUNCE_LIMIT_RESEND = 5000

/**
 * The maximum number of rows to display in breakdowns.
 * This is used in  the CountryCoordinatorLicensingTable component
 * to limit the number of rows shown in the skeleton loading state.
 */
export const MAX_BREAKDOWN_ROWS = 8

/**
 * Number of assets initially displayed on the Business screen.
 *
 * We set the number to 12 because it plays nicely in all views with the flex layout.
 *  */
export const ADDITIONAL_MAXIMUM_AMOUNT_OF_CARDS_TO_SHOW = 12
